module.exports = __webpack_public_path__ + "img/shousuo-you.b35ae489.svg";